export function cleanText(text: string): string {
  return text
    // Remove control characters except for \t \n
    .replace(/\x0B/g, "")

    // // Remove common Word bullet and symbol characters
    .replace(/[\u2022\u2023\u25AA-\u25CF\u25A0\u25CB\u25B6\u25C6\u25E6]/g, "")

    // // Remove Private Use Area symbols often seen as ""
    .replace(/[\uf0a7\uf0b7\uf0fc]/g, "")

    // // Replace non-breaking spaces and other odd spaces with regular spaces
    .replace(/[\u00A0\u1680\u180E\u2000-\u200F\u202F\u205F\u3000]/g, " ")

    // // Replace all forms of newline/CRLF with single line breaks
    .replace(/\r\n|\r|\n/g, "\n")

    // // Collapse all extra whitespace (space, tab, newline)
    .replace(/[ \t]+/g, " ")
    .replace(/\n{2,}/g, "\n\n")

    .trim();
}
